module.exports = __webpack_public_path__ + "media/frontend/svg/leftarrow-05b9ce0b800a36e474e76c6307b0e7a2.svg";